var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-card-briefing-money"},[_c('div',{staticClass:"card-white card-briefing rounded"},[_c('div',{staticClass:"circle-icons terciary"},[_c('i',{class:_vm.icon})]),_c('div',{staticClass:"content-text my-auto"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('h5',[_vm._v(_vm._s(_vm.value))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }